import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { RoutePaths } from '../Common/ClientRoutes';

import { CancelBtn, Input, MainBtn, DropDownMenu } from '../Common/form/Elements-export';
import { createService } from './epics-pharmacies';

import Images from '../Common/Images';
import ReactQuill from 'react-quill';
import reactCSS from 'reactcss';
import Svgs from '../Common/Svgs';

import localStorage from '../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

class AddService extends React.Component {
    state = {
        loadingSpinner: false,
        title: '',
        longTitle: '',
        imageSrc: Images.UPLOAD_PLACEHOLDER,
        hasImage: false,
        description: '',
        rteModules: {
            toolbar: [
                [{ size: ['normal', 'large', 'huge', 'small'] }], // custom dropdown
                ['bold', 'italic', 'underline', 'strike'] // toggled buttons
            ]
        },
        iFrameLink: '',
        serviceLink: '',
        appearance: this.props.appearance,
        serviceLanguage: '',
        validation: {
            title: '',
            longTitle: '',
            image: '',
            description: '',
            serviceLanguage: ''
        }
    };

    update = type => e => {
        this.setState({ ...this.state, [type]: e.target.value });
    };

    // upload image
    handleImageUpload = () => {
        this.Image.click();
    };

    handleImageChange = changeEvent => {
        let reader = new FileReader();
        let file = changeEvent.target.files[0];
        reader.onloadend = () => {
            this.setState({
                ...this.state,
                imageSrc: reader.result,
                hasImage: true
            });
        };
        if (changeEvent.target.files[0]) {
            reader.readAsDataURL(file);
        }
    };

    removeImage = e => {
        e.preventDefault();
        this.setState({
            ...this.state,
            imageSrc: Images.UPLOAD_PLACEHOLDER,
            hasImage: false
        });
        this.Image.value = '';
    };

    handleRTEChange = value => {
        this.setState({ ...this.state, description: value });
    };

    previewImage = () => {
        return {
            backgroundImage: `url("${this.state.imageSrc}")`,
            backgroundSize: 'cover'
        };
    };

    createServiceHandler = () => {
        let pharmacyId = this.props.match.params.pharmacyId,
            data = {
                title: this.state.title,
                longTitle: this.state.longTitle,
                language: this.state.serviceLanguage,
                description: this.state.description,
                iFrameLink: this.state.iFrameLink,
                serviceLink: this.state.serviceLink
            };

        if (this.state.hasImage) {
            data.image = this.state.imageSrc;
        }

        this.setState({ ...this.state, loadingSpinner: true });
        createService(data, pharmacyId)
            .then(() => {
                this.setState({ ...this.state, loadingSpinner: false });
                this.props.history.push('/pharmacies/pharmacy-details/' + pharmacyId);
            })
            .catch(error => {
                if (error) {
                    this.setState({
                        ...this.state,
                        loadingSpinner: false,
                        validation: {
                            title: this.generateErrorMessage(error.body, 'title')
                                .join(' ')
                                .trim(),
                            longTitle: this.generateErrorMessage(error.body, 'longTitle')
                                .join(' ')
                                .trim(),
                            image: this.generateErrorMessage(error.body, 'image')
                                .join(' ')
                                .trim(),
                            serviceLanguage: this.generateErrorMessage(error.body, 'language')
                                .join(' ')
                                .trim()
                        }
                    });
                }
            });
    };

    generateErrorMessage = (errArray, errName) => {
        return errArray.map(singleErr => {
            return singleErr.property_path === errName ? singleErr.message : '';
        });
    };

    generateErrorsMessages = message => (message === '' ? null : <div className="qf-error-message">{message}</div>);

    render() {
        const previewImage = reactCSS({
            default: {
                background: this.previewImage()
            }
        });

        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.pharmacy}</span>
                    </div>

                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title">
                                    <i className="fa fa-plus-square mr-2" />
                                    {strings.Add_pharmacy_service}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                <Link to={RoutePaths.PHARMACY_DETAILS(this.props.match.params.pharmacyId)} className="qf-back-btn">
                                    <i className="fa fa-chevron-left" />
                                    {strings.back}
                                </Link>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>

                        <div className="row qf-content-wrapper">
                            <div className="col-8 qf-mb-30 qf-left-column">
                                <div className="row">
                                    <Input
                                        handler={this.update('title')}
                                        inputType="text"
                                        label={`* ${strings.Add_service_name}`}
                                        placeholder={strings.Add_service_name_placeholder}
                                        extraClasses="col-6"
                                    />
                                    <DropDownMenu
                                        handler={this.update('serviceLanguage')}
                                        label={`* ${strings.service_language}`}
                                        extraClasses="col-6"
                                        placeholder={strings.service_language_placeholder}
                                        dropDownType="add"
                                    />
                                    <div className="col-6">{this.generateErrorsMessages(this.state.validation.title)}</div>
                                    <div className="col-6">{this.generateErrorsMessages(this.state.validation.serviceLanguage)}</div>
                                </div>

                                <div className="row">
                                    <div className="formInput col-4">
                                        <label>
                                            * {strings.Add_picture}
                                            {this.state.hasImage ? (
                                                <a onClick={this.removeImage} className="pull-right">
                                                    <i className="fa fa-trash-o" />
                                                </a>
                                            ) : null}
                                        </label>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-4">
                                        <div className="qf-upload-div">
                                            <a className="qf-upload-a" onClick={this.handleImageUpload}>
                                                <img
                                                    src={this.state.imageSrc}
                                                    alt="upload"
                                                    className="qf-background-service img-fluid mb-1"
                                                />
                                            </a>
                                        </div>
                                        <input
                                            type="file"
                                            name="backgroundImage"
                                            className="qf-hidden-element"
                                            id="backgroundImage"
                                            ref={input => (this.Image = input)}
                                            onChange={this.handleImageChange}
                                        />
                                    </div>
                                    <div className="col-8 small color-dark-gray">
                                        {strings.formatString(strings.Optimal_size, {
                                            width: 1500,
                                            height: 750
                                        })}
                                        <br />
                                        {strings.use_png}
                                    </div>
                                    <div className="col-12">{this.generateErrorsMessages(this.state.validation.image)}</div>
                                </div>

                                <div className="row">
                                    <Input
                                        handler={this.update('longTitle')}
                                        inputType="text"
                                        label={`* ${strings.Add_service_title}`}
                                        placeholder={strings.Add_service_title}
                                        extraClasses="col-12"
                                    />
                                    <div className="col-12">{this.generateErrorsMessages(this.state.validation.longTitle)}</div>
                                </div>

                                <div className="row">
                                    <div className="formInput col-12">
                                        <label>* {strings.Add_description}</label>
                                    </div>
                                    <div className="col-12">
                                        <div className="qf-editor-wrapper">
                                            <ReactQuill
                                                placeholder={strings.Service_description}
                                                modules={this.state.rteModules}
                                                value={this.state.description}
                                                onChange={this.handleRTEChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12">{this.generateErrorsMessages(this.state.validation.description)}</div>
                                </div>

                                <div className="row">
                                    <Input
                                        handler={this.update('iFrameLink')}
                                        inputType="text"
                                        label={strings.Link_to_iFrame}
                                        placeholder={strings.Link_to_iFrame_placeholder}
                                        extraClasses="col-12"
                                    />
                                </div>

                                <div className="row">
                                    <Input
                                        handler={this.update('serviceLink')}
                                        inputType="text"
                                        label={strings.Link_to_service}
                                        placeholder={strings.Link_to_service_placeholder}
                                        extraClasses="col-12"
                                    />
                                </div>
                            </div>

                            {/*mobile preview*/}
                            <div className="col-4 qf-mb-30 pt-5 qf-right-column">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="qf-mobile-preview mb-4">
                                            <div className="qf-responsive-padding">
                                                <div className="qf-responsive-holder">
                                                    <div className="qf-responsive-content">
                                                        <div
                                                            className="row no-gutters qf-service-main-title"
                                                            style={{
                                                                background: `linear-gradient(90deg, ${
                                                                    this.state.appearance.gradientFirstColor
                                                                }, ${this.state.appearance.gradientSecondColor})`
                                                            }}
                                                        >
                                                            <div className="col-12">
                                                                <i className="fa fa-chevron-left" />
                                                                {strings.Services}
                                                            </div>
                                                        </div>
                                                        <div className="row qf-preview-head-services no-gutters">
                                                            <div className="col-12" style={previewImage.background} />
                                                        </div>
                                                        <div className="row no-gutters">
                                                            <div className="col-12 p-2 color-blue">
                                                                {this.state.longTitle.length ? this.state.longTitle : strings.Service_title}
                                                            </div>
                                                            <div className="col-12 px-2">
                                                                <ReactQuill
                                                                    className="qf-preview-rich-text"
                                                                    value={
                                                                        this.state.description.length &&
                                                                        this.state.description !== '<p><br></p>'
                                                                            ? this.state.description
                                                                            : strings.Service_description
                                                                    }
                                                                    readOnly={true}
                                                                />
                                                            </div>
                                                            <div className="col-12 p-2">
                                                                <div className="qf-preview-more-btn">{strings.Learn_more}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 align-self-end">
                                        <div className="row">
                                            <div className="col-6 align-self-end">
                                                <Link to={RoutePaths.PHARMACY_DETAILS(this.props.match.params.pharmacyId)}>
                                                    {this.state.loadingSpinner ? (
                                                        <div className="px-5 text-center p-3" />
                                                    ) : (
                                                        <CancelBtn title={strings.cancel} extraClasses="qf-gray-btn w-100" />
                                                    )}
                                                </Link>
                                            </div>
                                            <div className="col-6 align-self-end">
                                                {this.state.loadingSpinner ? (
                                                    <div className="col-11 white-bg px-5 text-center p-3">
                                                        <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }} />
                                                    </div>
                                                ) : (
                                                    <MainBtn
                                                        onclick={this.createServiceHandler}
                                                        title={strings.Save}
                                                        extraClasses="qf-blue-btn w-100"
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(AddService);



// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/component-add-service.js